import actions from './actions';

const ClaimExcessModule = {
  namespaced: true,
  actions,
};

export default ClaimExcessModule;
